import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import {Container, Row, Col} from 'reactstrap';
import {prepareUrl} from '../../../../utilities/StringHelpers/StringHelpers';
import '../popupComponent/InfoEsimPopup.scss';
import EpiContext from '@episerver/spa-core/Spa';
import icon100insight from '../images/icon-100-insight.svg';

const InfoEsimPopup = (props) => {
  const url = props.esimData?.expandedValue[0]?.esimInstallationUrl?.value;

  return (
    <>
      {props.isPopUp ? (
        <>
          <div className='e-sim-popups'>
            <Image className='main-img' src={icon100insight} alt='regular-icon' />
            <div className='service-box-popup-header'>שימו לב</div>
            <div className='txt-block-1'>הפעילו את ה-eSIM רק בסיום תהליך הניוד</div>
            <div className='txt-block-2-bold'>איך תדעו שהניוד הסתיים?</div>
            <div className='txt-block-2'>תקבלו SMS על כך שניתן להוציא את</div>
            <div className='txt-block-2'>ה-SIM הישן ולעבור להפעלת ה-eSIM</div>
            <div className='btns'>
              <Container>
                <Row style={{flexWrap: 'inherit'}}>
                  <Col className='pr-0'>
                    <BtnSubmit style={{width: 'fit-content'}} onclick={() => prepareUrl(url, EpiContext)} text='הבנתי, בואו נמשיך' />
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default InfoEsimPopup;
